// @ts-nocheck
/* eslint-disable */
import { createReducer } from 'reduxsauce';
import produce from 'immer';
import { Types } from '../actions/category';

const initialState = {
  showCategoryDrawer: false,
  success: false,
  formFields: {
    name: '',
    description: '',
    is_default: false,
  },
  showSubCategoryDrawer: false,
  subCategoryFormFields: {
    name: '',
    description: '',
    parent: {},
  },
  confirmationModal: {
    show: false,
    type: '',
    id: null,
    parent: null,
  },
  searchText: '',
  pagination: {
    totalPages: null,
    total: null,
    perPage: 25,
    pageNumber: 1,
  },
  noteModal: {
    show: false,
    noteId: null,
    notes: [],
    message: '',
    categoryId: null,
    parentCategoryId: null,
    mode: null,
  },
  categories: [],
};

const openCategoryDrawer = (state) => ({
  ...state,
  showCategoryDrawer: true,
});

const closeCategoryDrawer = (state) => ({
  ...state,
  showCategoryDrawer: false,
});

const resetFormFields = (state) => ({
  ...state,
  formFields: initialState.formFields,
});

const updateFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;

  return {
    ...state,
    formFields: {
      ...state.formFields,
      [name]: value,
    },
  };
};

const createCategorySuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.default) {
    return {
      ...state,
      categories: produce(state.categories, (draft) => {
        const defaultCategory = draft.find((category) => category.default);
        if (defaultCategory) {
          defaultCategory.default = false;
        }
        draft.unshift(data);
      }),
    };
  }
  return {
    ...state,
    categories: [...state.categories, data],
  };
};

const getCategoriesSuccess = (state, action) => {
  const {
    payload: { data, total_pages, total, per_page, current_page },
  } = action;
  return {
    ...state,
    success: true,
    categories: data,
    pagination: {
      ...state.pagination,
      totalPages: total_pages,
      // perPage: per_page || 25,
      total: total,
      // pageNumber: current_page || 1,
    },
  };
};

const editCategory = (state, action) => ({
  ...state,
  formFields: { ...action.payload },
  showCategoryDrawer: true,
});

const updateCategorySuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.default) {
    return {
      ...state,
      categories: produce(state.categories, (draft) => {
        const defaultCategory = draft.find((category) => category.default);
        if (defaultCategory) {
          defaultCategory.default = false;
        }
        const index = draft.findIndex((category) => category.id === data.id);
        draft.splice(index, 1);
        draft.unshift(data);
      }),
    };
  }
  return {
    ...state,
    categories: produce(state.categories, (draft) => {
      const index = draft.findIndex((category) => category.id === data.id);
      draft.splice(index, 1, data);
    }),
  };
};

const deleteCategorySuccess = (state, action) => {
  const {
    payload: { id },
  } = action;

  return {
    ...state,
    categories: state.categories.filter((category) => category.id !== id),
  };
};

const openSubCategoryDrawer = (state, action) => {
  const {
    payload: {
      category: { id, name },
    },
  } = action;
  return {
    ...state,
    showSubCategoryDrawer: true,
    subCategoryFormFields: {
      ...state.subCategoryFormFields,
      parent: { id, name },
    },
  };
};

const closeSubCategoryDrawer = (state) => ({
  ...state,
  showSubCategoryDrawer: false,
});

const resetSubCategoryFormFields = (state, action) => {
  const {
    payload: { shouldCreateAnother },
  } = action;

  if (!shouldCreateAnother) {
    return {
      ...state,
      subCategoryFormFields: initialState.subCategoryFormFields,
    };
  }

  return {
    ...state,
    subCategoryFormFields: {
      ...state.subCategoryFormFields,
      name: '',
      description: '',
    },
  };
};

const updateSubCategoryFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;

  return {
    ...state,
    subCategoryFormFields: {
      ...state.subCategoryFormFields,
      [name]: value,
    },
  };
};

const createSubCategorySuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    categories: produce(state.categories, (draft) => {
      const selectedCategory = draft.find(
        (category) => category.id === data.parent,
      );
      selectedCategory.children.push(data);
    }),
  };
};

const editSubCategory = (state, action) => ({
  ...state,
  subCategoryFormFields: { ...action.payload },
  showSubCategoryDrawer: true,
});

const updateSubCategorySuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    categories: produce(state.categories, (draft) => {
      const selectedCategory = draft.find(
        (category) => category.id === data.parent,
      );

      const index = selectedCategory.children.findIndex(
        (subCategory) => subCategory.id === data.id,
      );
      selectedCategory.children.splice(index, 1, data);
    }),
  };
};

const deleteSubCategorySuccess = (state, action) => {
  const {
    payload: { id, parent },
  } = action;

  return {
    ...state,
    categories: produce(state.categories, (draft) => {
      const selectedCategory = draft.find((category) => category.id === parent);

      const index = selectedCategory.children.findIndex(
        (subCategory) => subCategory.id === id,
      );
      selectedCategory.children.splice(index, 1);
    }),
  };
};

const openConfirmationModal = (state, action) => {
  const {
    payload: { type, id, parent },
  } = action;
  return {
    ...state,
    confirmationModal: {
      show: true,
      type,
      id,
      parent,
    },
  };
};

const closeConfirmationModal = (state) => ({
  ...state,
  confirmationModal: initialState.confirmationModal,
});

const updateSearchText = (state, action) => {
  const {
    payload: { searchText },
  } = action;
  return {
    ...state,
    searchText,
  };
};

const updatePageNumber = (state, action) => {
  const {
    payload: { pageNumber },
  } = action;
  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageNumber,
    },
  };
};

const updatePerPage = (state, action) => {
  const clonedPagination = { ...state.pagination };

  clonedPagination.perPage = action.payload.perPage;
  if (
    clonedPagination.perPage >= clonedPagination.total ||
    clonedPagination.pageNumber >= clonedPagination.totalPages
  ) {
    clonedPagination.pageNumber = 1;
  }

  return {
    ...state,
    pagination: clonedPagination,
  };
};

const openNoteModal = (state, action) => {
  const {
    payload: { categoryId, parentCategoryId, notes },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      show: true,
      categoryId,
      parentCategoryId,
      notes,
    },
  };
};

const closeNoteModal = (state) => ({
  ...state,
  noteModal: initialState.noteModal,
});

const updateNoteMessage = (state, action) => {
  const {
    payload: { message },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      message,
    },
  };
};

const createNoteSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const {
    noteModal: { categoryId, parentCategoryId },
  } = state;

  if (parentCategoryId) {
    return {
      ...state,
      categories: produce(state.categories, (draft) => {
        const selectedCategory = draft.find(
          (category) => category.id === parentCategoryId,
        );

        const selectedSubCategory = selectedCategory.children.find(
          (subCategory) => subCategory.id === categoryId,
        );

        selectedSubCategory.notes.push(data);
      }),
    };
  }

  return {
    ...state,
    categories: produce(state.categories, (draft) => {
      const selectedCategory = draft.find(
        (category) => category.id === data.category,
      );
      selectedCategory.notes.push(data);
    }),
  };
};

const editNote = (state, action) => {
  const {
    payload: { noteId, message, mode },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      noteId,
      message,
      mode,
      notes: [],
    },
  };
};

const updateNoteSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const {
    noteModal: { noteId, categoryId, parentCategoryId },
  } = state;

  if (parentCategoryId) {
    return {
      ...state,
      categories: produce(state.categories, (draft) => {
        const selectedCategory = draft.find(
          (category) => category.id === parentCategoryId,
        );

        const selectedSubCategory = selectedCategory.children.find(
          (subCategory) => subCategory.id === categoryId,
        );

        const index = selectedSubCategory.notes.findIndex(
          (note) => note.id === noteId,
        );

        selectedSubCategory.notes.splice(index, 1, data);
      }),
    };
  }

  return {
    ...state,
    categories: produce(state.categories, (draft) => {
      const selectedCategory = draft.find(
        (category) => category.id === categoryId,
      );

      const index = selectedCategory.notes.findIndex(
        (note) => note.id === noteId,
      );
      selectedCategory.notes.splice(index, 1, data);
    }),
  };
};

const deleteNoteSuccess = (state, action) => {
  const {
    payload: { noteId },
  } = action;
  const {
    noteModal: { categoryId, parentCategoryId },
  } = state;

  if (parentCategoryId) {
    return {
      ...state,
      categories: produce(state.categories, (draft) => {
        const selectedCategory = draft.find(
          (category) => category.id === parentCategoryId,
        );

        const selectedSubCategory = selectedCategory.children.find(
          (subCategory) => subCategory.id === categoryId,
        );

        const index = selectedSubCategory.notes.findIndex(
          (note) => note.id === noteId,
        );

        selectedSubCategory.notes.splice(index, 1);
      }),

      noteModal: {
        ...state.noteModal,
        notes: state.noteModal.notes.filter((note) => note.id !== noteId),
      },
    };
  }

  return {
    ...state,
    categories: produce(state.categories, (draft) => {
      const selectedCategory = draft.find(
        (category) => category.id === categoryId,
      );

      const index = selectedCategory.notes.findIndex(
        (note) => note.id === noteId,
      );
      selectedCategory.notes.splice(index, 1);
    }),
    noteModal: {
      ...state.noteModal,
      notes: state.noteModal.notes.filter((note) => note.id !== noteId),
    },
  };
};
const categoryReducer = createReducer(initialState, {
  [Types.OPEN_CATEGORY_DRAWER]: openCategoryDrawer,
  [Types.CLOSE_CATEGORY_DRAWER]: closeCategoryDrawer,
  [Types.RESET_FORM_FIELDS]: resetFormFields,
  [Types.UPDATE_FORM_FIELD]: updateFormField,
  [Types.CREATE_CATEGORY_SUCCESS]: createCategorySuccess,
  [Types.GET_CATEGORIES_SUCCESS]: getCategoriesSuccess,
  [Types.EDIT_CATEGORY]: editCategory,
  [Types.UPDATE_CATEGORY_SUCCESS]: updateCategorySuccess,
  [Types.DELETE_CATEGORY_SUCCESS]: deleteCategorySuccess,
  [Types.OPEN_SUB_CATEGORY_DRAWER]: openSubCategoryDrawer,
  [Types.CLOSE_SUB_CATEGORY_DRAWER]: closeSubCategoryDrawer,
  [Types.UPDATE_SUB_CATEGORY_FORM_FIELD]: updateSubCategoryFormField,
  [Types.RESET_SUB_CATEGORY_FORM_FIELDS]: resetSubCategoryFormFields,
  [Types.CREATE_SUB_CATEGORY_SUCCESS]: createSubCategorySuccess,
  [Types.EDIT_SUB_CATEGORY]: editSubCategory,
  [Types.UPDATE_SUB_CATEGORY_SUCCESS]: updateSubCategorySuccess,
  [Types.DELETE_SUB_CATEGORY_SUCCESS]: deleteSubCategorySuccess,
  [Types.OPEN_CONFIRMATION_MODAL]: openConfirmationModal,
  [Types.CLOSE_CONFIRMATION_MODAL]: closeConfirmationModal,
  [Types.UPDATE_SEARCH_TEXT]: updateSearchText,
  [Types.UPDATE_PAGE_NUMBER]: updatePageNumber,
  [Types.UPDATE_PER_PAGE]: updatePerPage,
  [Types.OPEN_NOTE_MODAL]: openNoteModal,
  [Types.CLOSE_NOTE_MODAL]: closeNoteModal,
  [Types.UPDATE_NOTE_MESSAGE]: updateNoteMessage,
  [Types.CREATE_NOTE_SUCCESS]: createNoteSuccess,
  [Types.EDIT_NOTE]: editNote,
  [Types.UPDATE_NOTE_SUCCESS]: updateNoteSuccess,
  [Types.DELETE_NOTE_SUCCESS]: deleteNoteSuccess,
});

export default categoryReducer;
